import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, useSpring, useMotionValue } from 'framer-motion';

const MouseFollower = () => {
  const { pathname } = useLocation();
  
  // Startposition außerhalb des Bildschirms
  const mouseX = useMotionValue(-100);
  const mouseY = useMotionValue(-100);

  // Weiche Feder-Animation für das "langsame" Folgen
  const springConfig = { damping: 25, stiffness: 150, mass: 1.5 };
  const x = useSpring(mouseX, springConfig);
  const y = useSpring(mouseY, springConfig);

  useEffect(() => {
    const handleMouseMove = (e) => {
      // Zentriere das Logo (bei w-24=96px Breite -> 48px Offset)
      mouseX.set(e.clientX - 48);
      mouseY.set(e.clientY - 48);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [mouseX, mouseY]);

  // Auf der Startseite ('/') das Logo nicht anzeigen
  if (pathname === '/') {
    return null;
  }

  return (
    <motion.div
      className="fixed top-0 left-0 pointer-events-none z-[45] hidden md:block"
      // z-45 liegt unter der Navbar (z-50) aber über dem Content
      style={{ x, y }}
    >
      <img
        src="https://bikesmusicandmore.com/wp-content/uploads/2023/10/LOGO_BCB_2.png"
        alt=""
        className="w-24 h-auto opacity-20 filter drop-shadow-[0_0_15px_rgba(234,88,12,0.6)]"
      />
    </motion.div>
  );
};

export default MouseFollower;